import React from "react";

const Intro = () => {
  return (
    <div className="relative w-full h-screen object-cover z-10">
      {/* Marquee Notification */}
      <div className="absolute top-0 w-full  text-white text-sm md:text-md font-medium py-2 z-30">
        <div className="w-full overflow-hidden relative">
          <div className="whitespace-nowrap animate-marquee">
            📢 Free Admissions open for 2026 ! Apply Now | Special package for
            Std. VIII & Std. IX | Check the Latest News & Announcements on our
            Website.
          </div>
        </div>
      </div>

      {/* Image with rounded bottom */}
      <img
        src={"../../assets/school_wall_paper.jpeg"}
        alt="Overlayed"
        className="w-full h-4/6 object-cover rounded-bl-[15vw] rounded-br-[15vw]"
      />

      {/* Overlay Div */}
      <div className="absolute shadow-lg bottom-10 left-1/2 transform -translate-x-1/2 w-[85%] h-[65vh] sm:h-[60vh] md:h-[45vh] flex justify-center bg-white text-center font-bold text-lg rounded-lg p-4 z-20 overflow-hidden">
        <div className="max-w-3xl mx-auto">
          <h4 className="text-xl md:text-2xl font-semibold text-[#07294D] mb-2">
            Welcome to
          </h4>
          <h1 className="text-2xl md:text-4xl font-semibold text-[#07294D] mb-4">
            Shree Krishna Academy
          </h1>
          <p className="font-normal text-[#566F8B] ">
            Shree Krishna Academy, located in the tranquil surroundings of
            Teiyar Nawada, is a premier institution offering best education. Our
            eco-friendly campus provides a peaceful, nurturing environment for
            academic excellence, personal growth, and core values. Committed to
            shaping future leaders, we empower students with knowledge,
            creativity, and confidence to thrive and innovate.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Intro;
